export default "__VITE_ASSET__BWWiY0$G__"